import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { usePaginatedDataGrid } from "../../hooks/usePaginatedDataGrid";
import { PaginatedDataGridProps } from "./types";

export const PaginatedDataGrid: React.FC<PaginatedDataGridProps> = ({
  defaultPage = 0,
  defaultPageSize = 10,
  ...dataGridProps
}) => {
  const { paginationModel, handlePaginationModelChange } = usePaginatedDataGrid({
    defaultPage,
    defaultPageSize
  });

  return (
    <DataGrid
      {...dataGridProps}
      paginationModel={paginationModel}
      onPaginationModelChange={handlePaginationModelChange}
      paginationMode="server"
    />
  );
};
